import PhotoSwipe from 'photoswipe'
import React from 'react'
import { Gallery, Item } from 'react-photoswipe-gallery'

import 'photoswipe/dist/photoswipe.css'
import '@/styles/components/_horizontalGallery.scss'

//__INTERFACE
interface HorizontalGalleryProps {
  images: string[]
}

const HorizontalGallery: React.FC<HorizontalGalleryProps> = ({ images }) => {
  const options = {
    showHideOpacity: true,
    bgOpacity: 0.85,
    closeOnScroll: false,
    history: false
  }

  //__RENDER
  return (
    <Gallery options={options}>
      <div className='gallery-container'>
        {images.map((image, index) => (
          <Item
            key={index}
            original={image}
            thumbnail={image}
            width={1024}
            height={768}
            alt={`Gallery Image ${index + 1}`}>
            {({ ref, open }) => (
              <div onClick={open} className='gallery-item' role='button' tabIndex={0}>
                <img
                  ref={ref as unknown as React.MutableRefObject<HTMLImageElement>}
                  src={image}
                  alt={`Gallery Image ${index + 1}`}
                  loading='lazy'
                  className='gallery-image'
                  rel='preload'
                />
              </div>
            )}
          </Item>
        ))}
      </div>
    </Gallery>
  )
}

export default HorizontalGallery
